<template>
    <div class="header">
        <!-- 折叠按钮 -->
         <slot name="collapseBtn"></slot>
        <div class="logo">
            <img src="@/assets/img/icon-kpmglogo.svg" class="logo-icon" width="100%" />
            <span>{{ $t('COMMON_PROJECT_NAME') }}</span>
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <div class="btns">
                    <!-- 切换全屏 -->
                    <el-tooltip placement="bottom">
                        <template #content> {{ fullscreen ? $t('full_no_screen') : $t('full_screen') }} </template>
                        <template>
                            <div class="btn" style="display: flex;" @click="handleFullScreen">
                                <img v-if="fullscreen" src="@/assets/img/icon-Exit-fullscreen.svg" width="100%" />
                                <img v-else src="@/assets/img/icon-fullscreen.svg" width="100%" />
                            </div>
                        </template>
                    </el-tooltip>
                    <!-- 切换语言 -->
                    <el-tooltip placement="bottom">
                        <template #content> {{ $t('i18n_btn') }} </template>
                        <template>
                            <div class="btn" style="display: flex;" @click="handleCommand('i18nchange')">
                                <img v-if="this.$i18n.locale === 'zh'" src="@/assets/img/icon-EN.svg" width="100%" />
                                <img v-else src="@/assets/img/icon-CN.svg" width="100%" />
                            </div>
                        </template>
                    </el-tooltip>
                    <!-- 联系我们 -->
                    <el-tooltip placement="bottom" v-if="isKpmgUser&&false">
                        <template #content> {{ $t('Contact') }} </template>
                        <template>
                            <div class="btn" style="display: flex;" @click="handleCommand('Contact')">
                                <img src="@/assets/img/icon-contactus.svg" width="100%" />
                            </div>
                        </template>
                    </el-tooltip>
                    <!-- 联系我们 - 客户端 -->
                    <el-tooltip placement="bottom" v-if="isClientUser&&false">
                        <template #content> {{ $t('Contact') }} </template>
                        <template>
                            <div class="btn" style="display: flex;" @click="toogleSupportVisible">
                                <img src="@/assets/img/icon-contactus.svg" width="100%" />
                            </div>
                        </template>
                    </el-tooltip>
                    <!-- KCC视频简介 -->
                    <el-tooltip placement="bottom" v-if="false">
                        <template #content> {{ $t('KCC_short_introduction') }} </template>
                        <template>
                            <div class="btn" style="display: flex;" @click="handleShowKccVideo">
                                <img src="@/assets/img/icon-video.svg" width="100%" />
                            </div>
                        </template>
                    </el-tooltip>
                    <!-- faq -->
                    <el-tooltip placement="bottom">
                        <template #content> {{ $t('FAQ_TITLE') }} </template>
                        <template>
                            <div class="btn" style="display: flex;" @click="handleCommand('faq')">
                                <img src="@/assets/img/icon-FAQ.svg" width="100%" />
                            </div>
                        </template>
                    </el-tooltip>
                    <!-- portal -->
                    <el-tooltip placement="bottom" v-if="isKpmgUser">
                        <template #content> {{ $t('KCC_portal_TITLE') }} </template>
                        <template>
                            <div class="btn" style="display: flex;background: #cccccc42;border-radius: 15px;padding: 5px 10px;" @click="handleCommand('portal')">
                                <img src="@/assets/img/icon-kcc-portal.svg" style="position: relative; top: 1px" width="20px" />
                                <span style="font-size: 12px; margin-left: 4px; position: relative; top: 1px">KCC Portal</span>
                            </div>
                        </template>
                    </el-tooltip>
                </div>
                <!-- 用户头像 -->
                <div class="user-avatar" :style="{ backgroundImage: `url(${user.portrait})` }"></div>
                <!-- 用户名下拉菜单 -->
                <div class="user-name" v-if="isKpmgUser">
                    <div class="user-title">
                        <p class="name">{{ user.userName }}</p>
                        <p class="position">{{ user.title }}</p>
                    </div>
                </div>
                <el-dropdown
                    v-else
                    class="user-name"
                    trigger="click"
                    @visible-change="dropVisible"
                    @command="handleCommand"
                    :disabled="isKpmgUser"
                >
                    <span class="el-dropdown-link" style="display: flex; align-items: center">
                        <div class="user-title">
                            <p class="name">{{ user.userName }}</p>
                            <p class="position">{{ user.title }}</p>
                        </div>
                        <i :class="['el-icon-arrow-down', isArrowUp ? 'arrow-up' : '']" />
                    </span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-menu-operate">
                        <el-dropdown-item divided command="resetPassWord">
                            {{ $t('btn_resetPassword') }}
                        </el-dropdown-item>
                        <el-dropdown-item divided command="configTimeout">
                            {{ $t('configTimeout') }}
                        </el-dropdown-item>
                        <el-dropdown-item divided command="loginout">
                            {{ $t('login_out') }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <!--    配置超时时间---------start------>
        <el-dialog :title="$t('configTimeoutDialogTitle')" :visible.sync="timeoutVisible" width="20%" :show-close="false">
            <div class="center">
                <el-input-number v-model="outTime" :precision="1" :step="0.5" :max="8" :min="0.5"></el-input-number>
                {{ $t('hour') }}
                <div class="tip" style="color:#fd349c; text-align: left;">
                    <i class="el-icon-info"></i>
                    {{$t('outTimeTips')}}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="() => {timeoutVisible = false;}">{{ $t('btn_cancel') }}</el-button> -->
                <el-button type="primary" @click="setOutTime">{{ $t('btn_confirm') }}</el-button>
            </span>
        </el-dialog>
        <!--    配置超时时间---------end------>
        <contact-us v-if="supportVisible" :onCancel="toogleSupportVisible" :account="getUser.userAccount" />
        <short-videos v-if="videoListShow" :onCancel="toogleVideoShow" />
    </div>
</template>
<script>
import ContactUs from './ContactUs'
import ShortVideos from './ShortVideos'
import API from '@/api'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import windowConfig from '@/utils/windowConfig'

export default {
    data() {
        return {
            user: '',
            fullscreen: false,
            timeoutVisible: false,
            outTime: 0.5,
            supportVisible: false,
            videoListShow: false,
            isArrowUp: false
        }
    },
    components: {
        ContactUs,
        ShortVideos
    },
    inject: ['reload'],
    methods: {
        handleShowKccVideo() {
          localStorage.setItem('homepage_video_close_all', 1)
          this.$showVideoDialog()
          this.$nextTick(() => {
              this.$chooseVideo(1, false)
          })
        },
        dropVisible(flag) {
            this.isArrowUp = flag
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            switch (command) {
                case 'loginout':
                    API.common
                        .logout({ param: this.user.userAccount })
                        .then((res) => {
                            sessionStorage.removeItem('JSESSIONID')
                            localStorage.removeItem('JSESSIONID')
                            sessionStorage.removeItem('siteClassification')
                            this.$store.commit('common/setUser', {})
                            this.$store.commit('common/setSite', {})
                            this.$store.commit('common/setEntity', {})
                            this.$router.push('/login')
                        })
                        .catch((err) => {})
                        .finally(() => {})
                    break
                case 'i18nchange':
                    let locale = this.$i18n.locale
                    locale === 'zh' ? (this.$i18n.locale = 'en') : (this.$i18n.locale = 'zh')
                    localStorage.setItem('lang', this.$i18n.locale)
                    API.common.changeLanguage({ param: this.$i18n.locale }).then((res) => {
                        if (res.code == '1') {
                            this.reload()
                        }
                    })
                    break
                case 'resetPassWord':
                    this.$router.push('/changePassword')
                    break
                case 'resetUserName':
                    this.$router.push('/changeUserName')
                    break
                case 'howToUploadPBCFile':
                case 'howToConfigureKCCSite':
                case 'howToDownloadPBCFiles':
                case 'Contact':
                    window.open(windowConfig.helpURL[command], '_blank')
                    break
                case 'faq':
                    window.open(this.$t(`faq_${this.getUser.userType}`), '_blank')
                    // if (this.isKpmgUser) {
                    //     window.open(windowConfig.helpURL['faqKp'][this.$i18n.locale], '_blank')
                    // } else {
                    //     window.open('/#/faq', '_blank')
                    // }
                    break
                case 'configTimeout':
                    // this.getOutTime()
                    this.timeoutVisible = true
                    break
                case 'trainingVideos':
                    this.toogleVideoShow()
                    break
                case 'portal':
                    window.open(windowConfig.helpURL.portal, '_blank')
                    break
                default:
                    break
            }
        },
        async getOutTime() {
            const res = await API.pbc.getConfig()
            if (res.code == '1') {
                this.outTime = res.data.sessionTime ? res.data.sessionTime / 60 : 0.5
                localStorage.setItem('UID',res.data.userId)
            } else {
                this.$message.error(this.$t(res.code))
            }
        },
        async setOutTime() {
            const res = await API.pbc.setTime({ param: (this.outTime * 60).toString() })
            if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
            } else {
                this.$message.error(this.$t(res.code))
            }
            this.timeoutVisible = false
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen()
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen()
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen()
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen()
                }
            }
            this.fullscreen = !this.fullscreen
        },
        toogleSupportVisible() {
            this.supportVisible = !this.supportVisible
        },
        toogleVideoShow() {
            this.videoListShow = !this.videoListShow
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
        }),
        isClientUser() {
            return this.getUser.userType === '2'
        },
        isKpmgUser() {
            return this.getUser.userType === '1'
        }
    },
    mounted() {
        this.user = { ...this.getUser }
        this.user.portrait = this.user.portrait ? `data:image/*;base64,${this.user.portrait}` : require('@/assets/img/default-avatar.png')
        // if (this.user.cnUserName) this.user.userName = this.user.cnUserName
        this.getOutTime()
        Vue.prototype.$showVideoDialog = () => {
            this.videoListShow = true
        }
        Vue.prototype.$hideVideoDialog = () => {
            this.videoListShow = false
        }
        Vue.prototype.$showConfigOutTime = () => {
            this.handleCommand('configTimeout')
        }
    }
}
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    color: #ffffff;
    background-color: #1e49e2;
}

.header .logo {
    float: left;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.logo-icon {
    width: 155px;
    height: 100%;
    padding: 0 30px;
}

.logo span {
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    font-family: 'KPMG';
}

.header-right {
    float: right;
    padding-right: 25px;
}

.center {
    text-align: center;
}

.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}

.btn-fullscreen {
    margin-left: 30px;
    width: 30px;
    cursor: pointer;
}

.btn-bell {
    position: relative;
    width: 45px;
    height: 45px;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
}

.user-title {
    display: inline-block;
    margin-right: 15px;
}

.user-title .name {
    font-size: 18px;
    color: #ffffff;
}

.user-title .position {
    font-size: 16px;
    color: #ffffff;
    opacity: 0.6;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    margin-left: 15px;
}

.el-icon-arrow-down {
    color: #ffffff;
}

.user-avatar {
    display: block;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-link i {
    vertical-align: super;
    transition: transform 0.3s linear;
}
.arrow-up {
    transform: rotate(-180deg);
}
.el-dropdown-menu.dropdown-menu-operate .el-dropdown-menu__item {
    font-size: 12px;
}
.el-dropdown-menu__item {
    text-align: center;
}
.support-pointer {
    cursor: pointer;
    margin-right: 30px;
}
.support-icon {
    color: #fff;
    font-size: 34px;
    text-align: center;
    width: 100%;
}
.support-content {
    font-size: 16px;
    color: #fff;
}
.btns {
    display: flex;
    flex-direction: row;
}
.btns .btn {
    cursor: pointer;
    margin-right: 20px;
}
.faq-cls {
    width: 100%;
    display: inline-block;
    color: #606266;
}
.faq-cls:link,
.faq-cls:visited {
    color: #606266;
}
.faq-cls:active,
.faq-cls:hover {
    color: rgb(107, 179, 255);
}
</style>
